<template>
    <b-card>
        <!-- filter section -->
        <b-card-header>
            <b-row>
                <b-col cols="6">
                    <b-form-input
                        placeholder="Filter..."
                        addon-right-icon="ni ni-zoom-split-in"
                        v-model="query"
                    ></b-form-input>
                </b-col>
                <b-col cols="6">
                    <b-form-select
                        id="type"
                        v-model="filters.type"
                        :options="types"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >Select Type</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="6">
                    <b-form-select
                        id="user"
                        v-model="filters.user_id"
                        :options="users"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >Select User</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="3">
                    <b-form-input
                        placeholder="Date From"
                        type="date"
                        v-model="filters.date_from"
                    ></b-form-input>
                </b-col>

                <b-col cols="3">
                    <b-form-input
                        placeholder="Date To"
                        type="date"
                        v-model="filters.date_to"
                    ></b-form-input>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <!-- table to display the audit logs -->

            <b-table responsive :items="auditLogs" :fields="fields">
                <!-- field templates -->

                <!-- display the role as the first and last name of the user -->
                <template #cell(role)="{ item }">
                    <span>
                        {{ item.user.first_name + ' ' + item.user.last_name }}
                    </span>
                </template>

                <!-- display the message as html -->
                <template #cell(message)="{ item }">
                    <span v-html="item.message"></span>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'auditLogs-table',

    props: {
        type: {
            type: String,
        },
        title: String,
    },
    mixins: [permissionsMixins],
    data() {
        return {
            /** filter query */
            query: '',
            /** the current page being viewed */
            page: 1,
            /** the fields for the audit log table */
            fields: [
                {
                    key: 'created_at',
                    label: 'Date',
                    formatter: (value, key, item) =>
                        moment(new Date(item.created_at)).format('YYYY-MM-DD'),
                },
                'type',
                { key: 'order_id', label: 'Order' },
                'role',
                'message',
            ],
            filters: {
                type: null,
                user_id: null,
                date_from: null,
                date_to: null,
            },

            types: [
                'CREATE_ORDER',
                'DELETE_ORDER',
                'UPDATE_ORDER',
                'UPDATE_ORDER_ITEMS',
                'UPDATE_ORDER_CHECKLIST',
            ],
        }
    },

    computed: {
        auditLogs() {
            return this.$store.state.auditlogs.items
        },
        pagination() {
            return this.$store.state.auditlogs.pagination || {}
        },
        users() {
            return this.$store.getters['users/sorted_officers'].map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
    },

    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        'filters.user_id': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.type': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.date_from': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },

        'filters.date_to': function (filters) {
            console.log('filters', filters)
            this.doSearch()
        },
    },

    created() {
        this.$store.dispatch('users/fetchAll')
    },

    /** Search by filter criteria on component mount */
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        changePage(page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            const { query, page, filters } = this
            this.$store.dispatch('auditlogs/fetch', {
                query,
                page,
                filters,
            })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },
}
</script>
<style></style>
